import script from "./SchedulesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SchedulesList.vue?vue&type=script&lang=ts&setup=true"

import "./SchedulesList.vue?vue&type=style&index=0&id=09f6ee0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f6ee0f"]])

export default __exports__